<div class="pt-3 pl-md-4" *ngIf="notFound">
  <h2>Voucher pack not found</h2>
</div>

<div class="pt-3 pl-md-4" *ngIf="serverError !== null">
  <h2>Server Error: {{ serverError }}</h2>
</div>

<div class="pt-3 pl-md-4" *ngIf="loadingExistingVoucherPack">
  <h2>Loading Voucher Pack...</h2>
</div>

<div class="pt-3 pl-md-4" *ngIf="!myAccount.is_organization_admin">
  <h2>
    You do not have permission to
    {{ isNewVoucherPack ? 'create' : 'edit' }}
    voucher packs.
  </h2>
</div>

<div *ngIf="(serverError === null) && !notFound && !loadingExistingVoucherPack && myAccount.is_organization_admin">
  <nav class="navbar navbar-expand navbar-light bg-light capitan-sub-nav">
    <ul class="navbar-nav">
      <li class="nav-item">
        <a routerLink="/events/setup/voucher-packs" class="nav-link arrow-link">&#8592;</a>
      </li>
    </ul>

    <ul class="navbar-nav mx-auto">
      <li class="nav-item">
        <a class="nav-link" href="#"
           (click)="scrollToElement('setup');$event.preventDefault();"
           [class.active]="currentSectionId === 'setup'">
          Setup
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link" href="#"
           (click)="scrollToElement('pricing');$event.preventDefault();"
           [class.active]="currentSectionId === 'pricing'">
          Pricing
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link" href="#"
           (click)="scrollToElement('climber-app-text');$event.preventDefault();"
           [class.active]="currentSectionId === 'climber-app-text'">
          Climber App Text
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link" href="#"
           (click)="scrollToElement('restrictions');$event.preventDefault();"
           [class.active]="currentSectionId === 'restrictions'">
          Restrictions
        </a>
      </li>
      <li class="nav-item"
          *ngIf="orgConfig.getOrganizationConfig() && orgConfig.getOrganizationConfig().has_mailchimp_integration">
        <a class="nav-link" href="#"
           (click)="scrollToElement('mailchimp');$event.preventDefault();"
           [class.active]="currentSectionId === 'mailchimp'">
          Mailchimp
        </a>
      </li>
    </ul>

    <form class="form-inline">
      <button class="btn btn-primary btn-sm ml-2"
              [class.disabled]="loadingSubmit" [disabled]="loadingSubmit"
              type="button" (click)="handleSubmit()">
        {{ loadingSubmit ? 'Saving...' : 'Save' }}
      </button>
    </form>
  </nav>

  <div class="capitan-sub-nav-post-content" appScrollDetect>
    <div class="alert floating-alert alert-danger alert-dismissible" role="alert" *ngIf="errorMessage">
      {{ errorMessage }}
      <button type="button" class="close" (click)="errorMessage = ''">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="pt-3 pl-md-4 pb-5 mb-6">
      <h2>
        {{ isNewVoucherPack ? 'New Voucher Pack' : 'Edit Voucher Pack' }}
      </h2>

      <form (submit)="handleSubmit()">
        <div class="row mt-3">
          <div class="col-lg-10 col-xl-8"
               appScrollSpy [spiedTags]="['H3']" (sectionChange)="onSectionChange($event)">

            <h3 class="mt-2" id="setup">Setup</h3>

            <div class="form-group">
              <div class="row">
                <div class="col-lg-6 col-md-8">
                  <label for="nameInput">
                    Name
                  </label>
                  <input id="nameInput" type="text" name="name"
                         class="form-control"
                         [(ngModel)]="voucherPack.name"
                         (ngModelChange)="unsavedChanges = true">
                </div>
              </div>
              <div class="form-text text-danger">{{ errors.name }}</div>
            </div>

            <div class="form-group row">
              <div class="col-lg-6 col-md-8">
                <label for="statusSelect">Status</label>
                <select id="statusSelect" name="status"
                        class="custom-select"
                        [(ngModel)]="voucherPack.status"
                        (ngModelChange)="unsavedChanges = true">
                  <option *ngFor="let status of getAvailableStatuses()"
                          [ngValue]="status">
                    {{ getVoucherPackStatusDisplay(status) }}
                  </option>
                </select>
                <small class="form-text text-muted">
                  Once a voucher pack is set to Active (or Retired), it may not be reverted to Draft.
                </small>
                <div class="form-text text-danger">{{ errors.status }}</div>
              </div>
            </div>

            <div class="row">
              <div class="form-group col-lg-6 col-md-8">
                <label for="voucherType">Voucher Type</label>
                <select id="voucherType" name="voucherType"
                        class="custom-select"
                        [(ngModel)]="isEventTypeVoucher"
                        (ngModelChange)="handleIsEventTypeVoucherChange(); unsavedChanges = true;">
                  <option [ngValue]="true">Event Type</option>
                  <option [ngValue]="false">Event Category</option>
                </select>
                <small class="form-text text-muted">
                  Select whether this voucher pack pertains to an individual event type or an event category.
                </small>
              </div>
            </div>

            <div class="row">
              <div class="form-group col-lg-6 col-md-8">
                <div class="indented-subsection" *ngIf="isEventTypeVoucher">
                  <label for="voucherTypeSelect">Event Type</label>
                  <select id="voucherTypeSelectLoading" class="custom-select" name="voucher_type"
                          *ngIf="loadingEventTypes" disabled>
                    <option>Loading...</option>
                  </select>
                  <select id="voucherTypeSelect" class="custom-select" name="voucher_type"
                          *ngIf="!loadingEventTypes"
                          [(ngModel)]="voucherPack.event_type_id"
                          (ngModelChange)="unsavedChanges = true">
                    <option [ngValue]="null" disabled>---</option>
                    <option *ngIf="hasUnlistedEventType()"
                            [ngValue]="voucherPack.event_type_id">
                      {{ voucherPack.event_type_name }}
                      <ng-container *ngIf="voucherPack.event_type_status === EventTypeStatus.draft">(draft)</ng-container>
                      <ng-container *ngIf="voucherPack.event_type_status === EventTypeStatus.retired">(retired)</ng-container>
                    </option>
                    <option *ngFor="let eventType of eventTypes"
                            [ngValue]="eventType.id">
                      {{ eventType.name }}
                    </option>
                  </select>
                  <small class="form-text text-muted">
                    Only active event types may be selected.
                  </small>
                  <div class="form-text text-danger">{{ errors.event_type_id }}</div>
                </div>
                <div class="indented-subsection" *ngIf="!isEventTypeVoucher">
                  <label for="voucher_category_id">Event Category</label>
                  <select id="voucherCategorySelectLoading" class="custom-select" name="voucher_category_id"
                          *ngIf="loadingEventCategories" disabled>
                    <option>Loading...</option>
                  </select>
                  <select id="voucher_category_id" class="custom-select" name="voucher_category_id"
                          *ngIf="!loadingEventCategories"
                          [(ngModel)]="voucherPack.event_category_id"
                          (ngModelChange)="unsavedChanges = true">
                    <option [ngValue]="null" disabled>---</option>
                    <option *ngIf="eventCategoryRemoved(voucherPack.event_category_id)"
                            [ngValue]="voucherPack.event_category_id">
                      {{ voucherPack.event_category_name }} (Removed)
                    </option>
                    <option *ngFor="let eventCategory of eventCategories"
                            [ngValue]="eventCategory.id">
                      {{ eventCategory.name }}
                    </option>
                  </select>
                  <div class="form-text text-danger">{{ errors.event_category_id }}</div>
                </div>
              </div>
            </div>

            <div class="form-group">
              <label for="numVouchersInput">
                Number of Vouchers in Pack
              </label>
              <div class="row">
                <div class="col-lg-3 col-md-4 col-sm-5">
                  <input id="numVouchersInput" type="number" name="number_of_vouchers"
                         min="1" max="100" step="1"
                         class="form-control"
                         [(ngModel)]="voucherPack.number_of_vouchers"
                         (ngModelChange)="unsavedChanges = true">
                </div>
              </div>
              <div class="form-text text-danger">{{ errors.number_of_vouchers }}</div>
            </div>

            <h3 class="mt-2" id="pricing">Pricing</h3>

            <div class="form-group">
              <label for="priceInput">Price</label>
              <div class="row">
                <div class="input-group col-lg-3 col-md-4 col-sm-5">
                  <div class="input-group-prepend">
                    <span class="input-group-text">{{ orgConfig.getCurrencySymbol() }}</span>
                  </div>
                  <input id="priceInput" type="number" name="price"
                         placeholder="XXX.XX" min="0" step="0.01"
                         class="form-control"
                         [(ngModel)]="voucherPack.price"
                         (ngModelChange)="unsavedChanges = true">
                </div>
              </div>
              <div class="form-text text-danger">{{ errors.price }}</div>
            </div>

            <div class="row">
              <div class="form-group col-lg-6 col-md-8">
                <label for="taxRateSelect">Tax Rate</label>
                <div class="float-right">
                  <a href="#"
                     (click)="$event.preventDefault();loadTaxRates();">
                    Refresh Tax Rates
                  </a>
                  |
                  <a routerLink="/tax-rates-config" target="_blank">
                    Configure Tax Rates
                  </a>
                </div>
                <select id="taxRateSelectLoading" class="custom-select" name="tax_rate"
                        *ngIf="loadingTaxRates" disabled>
                  <option>Loading...</option>
                </select>
                <select id="taxRateSelect" class="custom-select" name="tax_rate"
                        *ngIf="!loadingTaxRates"
                        [(ngModel)]="voucherPack.tax_rate_id"
                        (ngModelChange)="unsavedChanges = true">
                  <option *ngIf="hasUnlistedTaxRate()"
                          [ngValue]="voucherPack.tax_rate_id">
                    {{ voucherPack.tax_rate_name }} (Removed)
                  </option>
                  <option *ngFor="let taxRate of taxRates"
                          [ngValue]="taxRate.id">
                    {{ taxRate.name }} - {{ taxRate.rate_percent }}%
                  </option>
                </select>
                <div class="form-text text-danger">{{ errors.tax_rate_id }}</div>
              </div>
            </div>

            <h3 class="mt-2" id="climber-app-text">Climber App Text</h3>

            <div class="form-group row">
              <div class="col-lg-10">
                <label>Description</label>
                <app-markdown-editor [id]="'descriptionTextarea'"
                                     [(content)]="voucherPack.description"
                                     (contentChange)="unsavedChanges = true"></app-markdown-editor>
                <small class="form-text text-muted">
                  This will be viewable by customers if they can purchase this voucher pack online.
                </small>
                <div class="form-text text-danger">{{ errors.description }}</div>
              </div>
            </div>

            <div class="form-group row">
              <div class="col-lg-10">
                <label>Purchase Confirmation Text</label>
                <app-markdown-editor [id]="'confirmationTextArea'"
                                     [(content)]="voucherPack.confirmation_text"
                                     (contentChange)="unsavedChanges = true"></app-markdown-editor>
                <small class="form-text text-muted">
                  This will be shown to customers on the confirmation screen after they purchase this voucher pack online.
                </small>
                <div class="form-text text-danger">{{ errors.confirmation_text }}</div>
              </div>
            </div>

            <div class="form-group row">
              <div class="col-lg-10">
                <label>Payment Information Text</label>
                <app-markdown-editor [id]="'paymentInfoTextArea'"
                                     [(content)]="voucherPack.payment_information_text"
                                     (contentChange)="unsavedChanges = true"></app-markdown-editor>
                <small class="form-text text-muted">
                  This will be shown to customers on their receipt after they purchase this voucher pack online.
                </small>
                <div class="form-text text-danger">{{ errors.payment_information_text }}</div>
              </div>
            </div>

            <div class="form-group row">
              <div class="col-lg-10">
                <label>Terms and Conditions Checkbox Text</label>
                <app-markdown-editor-single-line [id]="'tsAndCsCheckboxText'"
                                                 [(content)]="voucherPack.terms_and_conditions_checkbox_text"
                                                 (contentChange)="unsavedChanges = true">
                </app-markdown-editor-single-line>
                <small class="form-text text-muted">
                  This text will be shown alongside a checkbox which must be checked by the customer before purchasing this voucher pack. If this is left blank, no checkbox will be shown and it will not be required.
                </small>
              </div>
            </div>

            <h3 class="mt-2" id="restrictions">Restrictions</h3>

            <div class="form-group">
              <label for="expirationMonthsInput">Months Until Expiration</label>
              <div class="row">
                <div class="col-lg-3 col-md-4 col-sm-5">
                  <input id="expirationMonthsInput" type="number" name="expiration_months"
                         min="1" max="120" step="1"
                         class="form-control"
                         [(ngModel)]="voucherPack.expiration_months"
                         (ngModelChange)="unsavedChanges = true">
                </div>
              </div>
              <small class="form-text text-muted">
                The number of months that the voucher pack lasts before expiring. If this and "Days Until Expiration" are left blank, the voucher pack will not expire.
              </small>
              <div class="form-text text-danger">{{ errors.expiration_months }}</div>
            </div>

            <div class="form-group">
              <label for="expirationDaysInput">Days Until Expiration</label>
              <div class="row">
                <div class="col-lg-3 col-md-4 col-sm-5">
                  <input id="expirationDaysInput" type="number" name="expiration_days"
                         min="0" max="120" step="1"
                         class="form-control"
                         [(ngModel)]="voucherPack.expiration_days"
                         (ngModelChange)="unsavedChanges = true">
                </div>
              </div>
              <small class="form-text text-muted">
                The number of days that the voucher pack lasts before expiring. If this and "Months Until Expiration" are left blank, the voucher pack will not expire.
                <br>
                If both this and "Months Until Expiration" are provided, the time until expiration will be the sum of the two.
                <br>
                If this is set to zero (and "Months Until Expiration" is left blank), the voucher pack will expire at the end of the day that it is purchased.
              </small>
              <div class="form-text text-danger">{{ errors.expiration_days }}</div>
            </div>

            <div class="form-group">
              <div class="row">
                <div class="col-lg-6 col-md-8">
                  <label for="isStaffOnlySelect">Visibility</label>
                  <select id="isStaffOnlySelect" name="visibility"
                          class="custom-select"
                          [(ngModel)]="voucherPack.visibility"
                          (ngModelChange)="unsavedChanges = true">
                    <option [ngValue]="VoucherPackVisibility.public">Public</option>
                    <option [ngValue]="VoucherPackVisibility.unlisted">Unlisted</option>
                    <option [ngValue]="VoucherPackVisibility.staffOnly">Staff Only</option>
                  </select>
                </div>
              </div>
              <small class="form-text text-muted">
                Unlisted voucher packs will not be listed as a purchase option on the "Memberships, Passes, and Voucher Packs" Climber App page, but may still be purchased by anyone with the link. Staff Only voucher packs may only be purchased by staff members.
              </small>
              <small class="form-text text-muted">
                When using the Unlisted option, in order to provide additional assurance that only the intended customers are purchasing the voucher packs, you may additionally choose to take advantage of the "require staff approval" option below.
              </small>
              <div class="form-text text-danger">{{ errors.visibility }}</div>
            </div>

            <div class="form-group">
              <div class="row">
                <div class="col-lg-6 col-md-8">
                  <label for="allowUnlinkedPurchaseSelect">Allow Purchase for Unlinked Customers</label>
                  <select id="allowUnlinkedPurchaseSelect" name="allow_purchasing_for_unlinked_customers"
                          class="custom-select"
                          [(ngModel)]="voucherPack.allow_purchasing_for_unlinked_customers"
                          (ngModelChange)="unsavedChanges = true">
                    <option [ngValue]="true">Yes</option>
                    <option [ngValue]="false">No</option>
                  </select>
                </div>
              </div>
              <small class="form-text text-muted">
                If this is set to "Yes", then customers may manually enter the recipient's name and birthday when purchasing this voucher pack, in addition to the options of purchasing the voucher pack for themselves or a linked customer. If the manually-entered details cannot be matched to an existing customer, a new customer account will be created.
              </small>
              <div class="form-text text-danger">{{ errors.allow_purchasing_for_unlinked_customers }}</div>
            </div>

            <div class="form-group" *ngIf="voucherPack.allow_purchasing_for_unlinked_customers">
              <div class="row">
                <div class="col-lg-6 col-md-8">
                  <label for="allowPurchaseWithoutLoginSelect">Allow Purchase when Not Logged Into Climber App</label>
                  <select id="allowPurchaseWithoutLoginSelect" name="allow_purchase_without_login"
                          class="custom-select"
                          [(ngModel)]="voucherPack.allow_purchase_without_login"
                          (ngModelChange)="unsavedChanges = true">
                    <option [ngValue]="true">Yes</option>
                    <option [ngValue]="false">No</option>
                  </select>
                </div>
              </div>
              <small class="form-text text-muted">
                If this is set to "Yes", then customers may purchase this voucher pack without being logged in to the Climber App. They will be asked to enter their name, birthday, and email address instead.
              </small>
              <div class="form-text text-danger">{{ errors.allow_purchase_without_login }}</div>
            </div>

            <ng-container *ngIf="orgConfig.getOrganizationConfig() && orgConfig.getOrganizationConfig().has_mailchimp_integration">
              <h3 class="mt-2" id="mailchimp">Mailchimp Tags and Events</h3>

              <p class="text-muted">
                To learn more, see our
                <a href="https://capitan.helpscoutdocs.com/article/200-mailchimp-events-and-tags"
                   target="_blank" rel="noopener">support article on the Capitan Mailchimp integration</a>.
              </p>

              <p class="mb-1">
                The following events are synced to Mailchimp automatically for all voucher packs:
              </p>
              <div class="rounded-table-wrapper rounded-table-tight mb-3 mailchimp-auto-events-table">
                <table class="table table-sm mb-0">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Type</th>
                      <th>Synced To</th>
                      <th>When</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td><code>voucher_purchased_by_cust</code></td>
                      <td>Event</td>
                      <td>Purchaser</td>
                      <td>When a voucher pack of this type is purchased</td>
                    </tr>
                    <tr>
                      <td><code>voucher_purchased_for_cust</code></td>
                      <td>Event</td>
                      <td>Recipient</td>
                      <td>When a voucher pack of this type is purchased</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="form-group">
                <label for="mailchimpUnusedVouchersTagNameInput">
                  "Unused Vouchers" Tag Name
                </label>
                <div class="row">
                  <div class="col-lg-6 col-md-8">
                    <input id="mailchimpUnusedVouchersTagNameInput"
                           type="text" name="mailchimp_unused_vouchers_tag_name"
                           maxlength="64"
                           class="form-control"
                           [(ngModel)]="voucherPack.mailchimp_unused_vouchers_tag_name"
                           (ngModelChange)="unsavedChanges = true">
                  </div>
                </div>
                <small class="form-text text-muted">
                  If provided, this tag will be assigned in Mailchimp to all customers with unused vouchers (vouchers with at least one use remaining) purchased via this voucher pack.
                  <br>
                  It may take up to 15 minutes to update all existing customers when this field is changed.
                </small>
                <div class="form-text text-danger">{{ errors.mailchimp_unused_vouchers_tag_name }}</div>
              </div>

              <div class="form-group">
                <label for="mailchimpLastVoucherUsedEventNameInput">"Last Voucher Used" Event Name</label>
                <div class="row">
                  <div class="col-lg-6 col-md-8">
                    <input id="mailchimpLastVoucherUsedEventNameInput"
                           type="text" name="mailchimp_last_voucher_used_event_name"
                           maxlength="30"
                           class="form-control"
                           [(ngModel)]="voucherPack.mailchimp_last_voucher_used_event_name"
                           (ngModelChange)="unsavedChanges = true">
                  </div>
                </div>
                <small class="form-text text-muted">
                  If provided, this event will be created in Mailchimp whenever a customer uses their last voucher of a voucher pack of this type.
                  <br>
                  Mailchimp event names must be between 2 and 30 characters in length, and must consist only of letters, numbers, underscores, and dashes.
                </small>
                <div class="form-text text-danger">{{ errors.mailchimp_last_voucher_used_event_name }}</div>
              </div>

              <div class="form-group">
                <label for="mailchimpPurchasedByCustomerEventNameInput">
                  "Voucher Pack Purchased By Customer" Event Name
                </label>
                <div class="row">
                  <div class="col-lg-6 col-md-8">
                    <input id="mailchimpPurchasedByCustomerEventNameInput"
                           type="text" name="mailchimp_purchased_by_customer_event_name"
                           maxlength="30"
                           class="form-control"
                           [(ngModel)]="voucherPack.mailchimp_purchased_by_customer_event_name"
                           (ngModelChange)="unsavedChanges = true">
                  </div>
                </div>
                <small class="form-text text-muted">
                  If provided, this event will be created in Mailchimp for the purchaser whenever a voucher pack of this type is purchased. This is in addition to the generic "voucher_purchased_by_cust" event, which is created for the purchaser on all voucher pack purchases.
                  <br>
                  Mailchimp event names must be between 2 and 30 characters in length, and must consist only of letters, numbers, underscores, and dashes.
                </small>
                <div class="form-text text-danger">{{ errors.mailchimp_purchased_by_customer_event_name }}</div>
              </div>

              <div class="form-group">
                <label for="mailchimpPurchasedForCustomerEventNameInput">
                  "Voucher Pack Purchased For Customer" Event Name
                </label>
                <div class="row">
                  <div class="col-lg-6 col-md-8">
                    <input id="mailchimpPurchasedForCustomerEventNameInput"
                           type="text" name="mailchimp_purchased_for_customer_event_name"
                           maxlength="30"
                           class="form-control"
                           [(ngModel)]="voucherPack.mailchimp_purchased_for_customer_event_name"
                           (ngModelChange)="unsavedChanges = true">
                  </div>
                </div>
                <small class="form-text text-muted">
                  If provided, this event will be created in Mailchimp for the recipient whenever a voucher pack of this type is purchased. This is in addition to the generic "voucher_purchased_for_cust" event, which is created for the recipient on all voucher pack purchases.
                  <br>
                  Mailchimp event names must be between 2 and 30 characters in length, and must consist only of letters, numbers, underscores, and dashes.
                </small>
                <div class="form-text text-danger">{{ errors.mailchimp_purchased_for_customer_event_name }}</div>
              </div>
            </ng-container>

            <app-last-updated-by-footer
              [updatedAt]="voucherPack.updated_at"
              [firstName]="voucherPack.last_updated_by_first_name"
              [lastName]="voucherPack.last_updated_by_last_name"
              [email]="voucherPack.last_updated_by_email"
            ></app-last-updated-by-footer>

          </div>
        </div>

        <!-- Allows inputs to submit when enter is pressed -->
        <button type="submit" class="d-none">Hidden submit button</button>
      </form>
    </div>
  </div>
</div>
